/**
 * Minimum properties associated with the `data-automation-type` property.
 *
 * The data automation type is used to identify components across the variations of the
 * ribbon (MLR vs. SLR).
 */
export type StateWithDataAutomationType = {
  root: {
    "data-automation-type"?: string;
  };
};

/**
 * Process the `state` as a mutable draft state and set the `data-automation-type` property according
 * to `valueOrDefaultValue`.
 */
export function useDataAutomationType<T extends StateWithDataAutomationType>(
  state: T,
  value?: string
) {
  if (value !== undefined) {
    state.root["data-automation-type"] = value;
  }
}
